import { OpenAPI as KeymasterAPI } from './keymaster';
import { OpenAPI as KeymasterV2API } from './V2/keymaster';
import { OpenAPI as GozerV2API } from './V2/gozer';
import { OpenAPI as GozerV3API } from './V3/gozer';
import { OpenAPI as PadreAPI } from './padre';
import { OpenAPI as PadreV2API } from './V2/padre';
import { OpenAPI as LonghornAPI } from './longhorn';
import { OpenAPI as LonghornV2API } from './V2/longhorn';
import { OpenAPI as LonghornV3API } from './V3/longhorn';
import { OpenAPI as AurascopeAPI } from './aurascope';
import { OpenAPI as AurascopeV2API } from './V2/aurascope';
import { OpenAPI as CharonV2API } from './V2/charon';
import { OpenAPI as CharonV3API } from './V3/charon';

/* API configuration */
KeymasterAPI.BASE = ""
KeymasterV2API.BASE = ""
GozerV2API.BASE = ""
GozerV3API.BASE = ""
PadreAPI.BASE = ""
PadreV2API.BASE = ""
LonghornAPI.BASE = ""
LonghornV2API.BASE = ""
LonghornV3API.BASE = ""
AurascopeAPI.BASE = ""
AurascopeV2API.BASE = ""
CharonV2API.BASE = ""
CharonV3API.BASE = ""

/* Always get latest token from NexusAuthprovider */
KeymasterAPI.TOKEN = async () => {
    return await authProvider.getNexusToken()
}
KeymasterV2API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}

GozerV2API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}

GozerV3API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}

PadreAPI.TOKEN = async () => {
    return await authProvider.getNexusToken()
}
PadreV2API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}

LonghornAPI.TOKEN = async () => {
    return await authProvider.getNexusToken()
}
LonghornV2API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}
LonghornV3API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}

AurascopeAPI.TOKEN = async () => {
    return await authProvider.getNexusToken()
}
AurascopeV2API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}
CharonV2API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}
CharonV3API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}

export interface ISecurity {
    authenticationState: string;
    getAccessToken?: (() => Promise<string>);
    login: () => void;
    logout: () => void;
}

export function isExpired(time: Date) {
    const millisRemaining = time.getTime() - Date.now();
    return millisRemaining < 5000 ? true : false;
}

export class NexusAuthProvider {
    protected _accessToken: any;

    public getNexusToken = async (): Promise<string> => {
        // var parent = window.parent.document?.getElementById("serviceAddresses");
        // var token = parent?.getAttribute('data-token') ?? "";
        // this._accessToken = JSON.parse(token)
        const _nexusTokenRequest = (resolve, reject) => {
            if (!this._accessToken) {
                reject("No token provided")
            } else if (isExpired(new Date(this._accessToken.refreshTokenExpires)) || isExpired(new Date(this._accessToken.tokenExpires))) {
                reject("Token has expired")
            } else {
                resolve(this._accessToken.token);
            }
        }
        return new Promise<string>(_nexusTokenRequest);
    }

    public setToken = (token: any): any => {
        this._accessToken = token;
    }

    public getPermissions = (): any => {
        if (this._accessToken !== null) {
            return JSON.parse(atob(this._accessToken.token.split('.')[1])).Permissions;
        }
    }

    public getUser = (): any => {
        if (this._accessToken !== null) {
            return JSON.parse(atob(this._accessToken.token.split('.')[1]));
        }
        return null;
    }

    public logoutCredentials = () => {
        this._accessToken = null;
    }
}

export const authProvider = new NexusAuthProvider();